export default "__VITE_ASSET__BtOlRwLZ__"